var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconInfo32(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.25a.75.75 0 01.743.648l.007.102v7a.75.75 0 01-1.493.102L15.25 21v-7a.75.75 0 01.75-.75zM17 11a1 1 0 11-2 0 1 1 0 012 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 16C4.25 9.51 9.51 4.25 16 4.25S27.75 9.51 27.75 16 22.49 27.75 16 27.75 4.25 22.49 4.25 16zm22 0c0-5.66-4.59-10.25-10.25-10.25S5.75 10.34 5.75 16 10.34 26.25 16 26.25 26.25 21.66 26.25 16z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo32);
export default __webpack_public_path__ + "static/media/icon-info-32.f410a022.svg";
export { ForwardRef as ReactComponent };